import { probeHex } from "./ComputedColour";

export const DeriveAction = {
  mounted() {
    this.el.addEventListener("click", () => {
      this.pushEvent("lab_derive_action", {
        light_rgb: probeHex("--light-action"),
        dark_rgb: probeHex("--dark-action"),
      });
    });
  },
};
